import { createRouter, createWebHistory, createMemoryHistory, RouteRecordRaw, } from 'vue-router';
import ARMS from '@/common/arms';
import { LogReporter } from '@/common/log-report';
import { LayoutTypes } from '@/constants/layout';
import { PageSpmId, PageName } from '@/constants/page';

const routes: RouteRecordRaw[] = [
  {
    path: '/:sLocale(th|en|vi|id|ms)?',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: 'live/h5/charge-strip',
        name: PageName.ChargeStrip,
        component: () => import('@/pages/h5/charge-strip/charge-strip.vue'),
        meta: {
          layoutType: LayoutTypes.Pure
        }
      },
      {
        path: 'live/h5/blind-box-award',
        name: PageName.BlindBoxAward,
        component: () => import('@/pages/h5/blind-box-award/blind-box-award.vue'),
        meta: {
          layoutType: LayoutTypes.Pure
        }
      },
      {
        path: 'live/:roomId(\\d+)',
        name: PageName.LiveRoom,
        component: () => import('@/pages/room/room.vue'),
        strict: true,
        meta: {
          layoutType: LayoutTypes.Default
        }
      },
      {
        path: 'live',
        name: PageName.LiveHome,
        component: () => import('@/pages/home/home.vue'),
        strict: true,
        meta: {
          layoutType: LayoutTypes.WithSidebar
        }
      },
      {
        path: 'm-live/:roomId(\\d+)',
        name: PageName.H5LiveRoom,
        component: () => import('@/pages/h5-room/room.vue'),
        strict: true,
        meta: {
          layoutType: LayoutTypes.H5
        }
      },
      {
        path: ':pathMatch(.*)*',
        name: PageName.NotFound,
        component: () => import('@/components/error/404.vue'),
        meta: {
          layoutType: LayoutTypes.Default
        }
      }
    ]
  },
];

export default () => {

  const router = createRouter({
    history: import.meta.env.SSR ? createMemoryHistory() : createWebHistory(),
    routes,
  });

  if (!import.meta.env.SSR) {
    router.afterEach((to, from) => {

      ARMS.setPage(to.name as string);
      ARMS.sendPerf(to.name as string);

      const spmId = PageSpmId[to.name as PageName];
      if (spmId) {
        LogReporter.setSpmId(spmId);
        LogReporter.sendPV();
      }
    });
  }

  return router;
};
